
<template>
  <div :style="{ margin: '2rem' }">
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
    <ConfirmationModal
      :active="confirmModal"
      :handleConfirm="handleAcceptConfirmModal"
      :handleCancel="handleCancelConfirmModal"
      title="Remover tamanho"
      message="Você tem certeza que deseja deletar esse tamanho?"
    />
    <v-card>
      <v-data-table
        :headers="headers"
        :items="sizeLots"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :disable-sort="true"
        :loading="loading"
        loading-text="Carregando... Por favor, aguarde"
        no-data-text="Nenhum tamanho encontrado"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-bold">Tamanhos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Novo Tamanho
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-select
                            v-model="sizeLot.property"
                            item-text="name"
                            item-value="id"
                            no-data-text="Sem dados"
                            :items="properties"
                            :rules="obrigatoryRule"
                            label="Empreendimento"
                            required
                            :disabled="!modeCreate"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="sizeLot.name"
                            :rules="obrigatoryRule"
                            label="Nome"
                            maxlength="100"
                            required
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue" :disabled="!valid" text @click="validate">Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="edit(item)"
          >
            mdi-circle-edit-outline
          </v-icon>
          <v-icon
            small
            @click="openConfirmModal(item)"
          >
            mdi-delete-empty
          </v-icon>
        </template>
        <template v-slot:no-data>
          Sem dados
        </template>
      </v-data-table>
      <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
    </v-card>
  </div>
</template>

<script>
import DialogLoading from '@/components/loading/DialogLoading'
import ConfirmationModal from '@/components/modals/ConfirmationModal'
import message from '@/utils/message'
import api from '@/services/api'

export default {
  components: {
    DialogLoading,
    ConfirmationModal
  },

  data: () => ({
    confirmModal: false,
    hasSure: false,
    itemToDelete: null,
    dialog: false,
    loading: true,
    loadingMessage: 'Carregando',
    valid: true,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    obrigatoryRule: [
      v => !!v || 'Informação obrigatória'
    ],
    headers: [
      { text: 'Empreendimento', align: 'start', value: 'property.name' },
      { text: 'Nome', value: 'name' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    properties: [],
    sizeLots: [],
    editedIndex: -1,
    editedId: false,
    sizeLot: {
      id: null,
      name: null,
      property: null
    },
    defaultItem: {
      id: null,
      name: null,
      property: null
    }
  }),

  computed: {
    modeCreate () {
      return this.editedIndex === -1
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Novo Tamanho' : 'Editar Tamanho'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.getProperties()
    this.getSizeLots()
  },

  methods: {
    async getSizeLots () {
      try {
        const { data } = await api.get('/size-lots')
        this.sizeLots = data
      } catch (error) {
        message.error('Erro ao buscar Tamanhos')
      } finally {
        this.loading = false
      }
    },

    async getProperties () {
      try {
        const { data } = await api.get('/properties')
        this.properties = data
      } catch (error) {
        message.error('Erro ao buscar empreendimentos')
      } finally {
        this.loading = false
      }

      this.loading = false
    },

    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },

    async edit (item) {
      this.loadingMessage = 'Carregando'
      this.loading = true

      this.editItemToTable(item)
      this.loading = false
    },

    editItemToTable (item) {
      this.editedIndex = this.sizeLots.indexOf(item)
      this.editedId = item.id
      this.sizeLot = Object.assign({}, item)
      this.dialog = true
    },

    async deleteItem () {
      if (this.hasSure) {
        this.loadingMessage = 'Removendo'
        this.loading = true

        try {
          await api.delete(`/size-lots/${this.itemToDelete.id}`)
          message.success('Tamanho removido')
          this.removeToTable(this.itemToDelete)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      }
    },

    openConfirmModal (item) {
      this.itemToDelete = item
      this.confirmModal = true
    },

    handleCancelConfirmModal () {
      this.hasSure = false
      this.confirmModal = false
    },

    handleAcceptConfirmModal () {
      this.hasSure = true
      this.confirmModal = false
      this.deleteItem()
    },

    removeToTable (item) {
      const index = this.sizeLots.indexOf(item)
      this.sizeLots.splice(index, 1)
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.sizeLot = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async save () {
      let data = {
        name: this.sizeLot.name,
        property_id: this.sizeLot.property.id ? this.sizeLot.property.id : this.sizeLot.property
      }

      this.loading = true

      if (this.editedIndex === -1) {
        this.loadingMessage = 'Salvando'

        try {
          const response = await api.post('/size-lots', data)
          message.success('Tamanho salvo')
          this.addToTable(response.data)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      } else {
        this.loadingMessage = 'Atualizando'

        try {
          const response = await api.put(`/size-lots/${this.editedId}`, data)
          message.success('Tamanho atualizado')
          this.addToTable(response.data)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      }
    },

    addToTable (item) {
      if (this.editedIndex > -1) {
        Object.assign(this.sizeLots[this.editedIndex], this.sizeLot)
      } else {
        this.sizeLots.push(item)
      }
      this.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sizeLots/SizeLots.vue